const IF = ({ condition, children }) => {
    return condition ? children : null;
};

export default IF;
